import { SelectionModel } from '@angular/cdk/collections';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChildren,
  QueryList,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef
} from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { CarModelTypeService } from 'src/app/car-model-type/car-model-type.service';
import { LabelPrintComponent } from 'src/app/computer/label-print/label-print.component';
import { AppState } from 'src/app/redux/app.state';
import { NotificationService } from 'src/app/services/notification.service';
import { SupportService } from 'src/app/support.service';
import { DocTypeEnum } from 'src/enums';
import { environment } from 'src/environments/environment';
import { CarModelType, Product, ProductInWarehouse, User, Warehouse } from 'src/typings';
import { CardComponent } from '../card/card.component';
import { ProductService } from '../product.service';
import { MarkupService } from 'src/app/markup-table/markup.service';
import { PartPhotoViewerDialogComponent } from '../../new-catalog/products/part-info/part-photo-viewer-dialog.component';

@Component({
  selector: 'app-product-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent implements OnInit, OnDestroy {
  widthDisplay = 0;

  constructor(
    private productService: ProductService,
    public supportService: SupportService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private carService: CarModelTypeService,
    private markUpService: MarkupService
  ) {
    this.productService.productGw.subscribe((list) => {
      if (!list) return;
      const updatedList = [...this.dataSource.data];
      for (let index = 0; index < list.length; index++) {
        const product = list[index];
        const foundIndex = updatedList.findIndex((prod) => prod.id === product.id);
        if (foundIndex >= 0) {
          updatedList[foundIndex] = { ...updatedList[foundIndex], ...product };
        }
      }
      this.dataSource.data = updatedList;
    });
    this.store.subscribe((data) => {
      this.user = data.user.info;
    });
    this.widthDisplay = window.innerWidth;
    if (this.analogueSelector) {
      if (this.widthDisplay < 600) {
        this.displayedColumns = ['select', 'mobileDescriptionAddAnalgoue'];
      } else {
        this.displayedColumns = ['id', 'description', 'brand', 'article', 'select'];
      }
    } else {
      this.displayedColumns = [
        'id',
        'description',
        'brand',
        'article',
        'price',
        'stock',
        'priceControl',
        'quanControl',
        'select'
      ];
    }
  }

  loading = false;

  displayedColumns: string[] = [];

  dataSource = new MatTableDataSource<Product>([]);

  selection = new SelectionModel<Product>(true, []);

  changeRow: any | undefined;

  analogueSelector = false;

  user: User | undefined;

  @Input() car: CarModelType | undefined;

  @Output() toggleProductEvent = new EventEmitter<Product>();

  @Output() toggleAllProductEvent = new EventEmitter<Product[]>();

  @Output() removeProductEvent = new EventEmitter<Product>();

  @Output() addProductEvent = new EventEmitter<Product>();

  @Input() controls: UntypedFormArray = new UntypedFormArray([]);

  @Input() analogueSearchProductId: number | null | undefined;

  @Input() loadProductsEvent: EventEmitter<Product[]> | undefined;

  @Input() defaultWarehouse: Warehouse | undefined;

  @Input() movingWarehouseFrom: Warehouse | null | undefined;

  @Input() movingWarehouseTo: Warehouse | null | undefined;

  @Input() movingOriginalWarehouseFromId: number | null | undefined;

  @Input() movingOriginalWarehouseToId: number | null | undefined;

  @Input() movingOriginalQuantities: Record<number, number> = {};

  @Input() movingOriginalPassed = false;

  private movingRouteModeValue = false;

  @Input() set movingRouteMode(value: boolean) {
    this.movingRouteModeValue = Boolean(value);
    if (this.movingRouteModeValue) {
      this.displayedColumns = this.getMovingRouteColumns();
    }
  }

  get movingRouteMode() {
    return this.movingRouteModeValue;
  }

  @Input() docType: DocTypeEnum | undefined;

  get compactSearchPanel(): boolean {
    return this.docType === DocTypeEnum.order || this.docType === DocTypeEnum.buy;
  }

  @Input() documentEditMode = false;

  @Input() receivingMode = false;
  @Output() closeRequested = new EventEmitter<void>();
  searchError = '';
  searched = false;

  @Input() keyboardMode = false;
  @Output() keyboardProductChosen = new EventEmitter<Product>();
  @ViewChildren('keyboardRow', { read: ElementRef }) keyboardRows?: QueryList<ElementRef<HTMLElement>>;
  keyboardActiveId: number | null = null;
  private keyboardResultQuery = '';
  private keyboardChoosing = false;
  private focusTimer?: ReturnType<typeof setTimeout>;
  private destroyed = false;
  private failedImageUrls = new Set<string>();

  @ViewChild('articleInput') articleInput: ElementRef | undefined;

  searchForm: UntypedFormGroup = new UntypedFormGroup({
    article: new UntypedFormControl(),
    brand: new UntypedFormControl(''),
    description: new UntypedFormControl(''),
    barcode: new UntypedFormControl()
  });

  ngOnInit(): void {
    this.focusTimer = setTimeout(() => {
      if (!this.destroyed) this.articleInput?.nativeElement.focus();
    }, this.keyboardMode ? 0 : 500);

    if (this.loadProductsEvent)
      this.loadProductsEvent.subscribe((list) => {
        const productsInView = this.dataSource.data.filter((prod) => {
          return list.find((prodInReturn) => prodInReturn.id === prod.id);
        });
        this.selection.select(...productsInView);
      });

    if (this.receivingMode) {
      this.displayedColumns = ['img', 'description', 'brand', 'article', 'stock', 'receive'];
      return;
    }
    if (this.movingRouteMode) {
      this.displayedColumns = this.getMovingRouteColumns();
      return;
    }

    switch (this.docType) {
      case DocTypeEnum.export:
        this.displayedColumns = [
          'id',
          'description',
          'brand',
          'article',
          'retail',
          'stock',
          'priceControl',
          'quanControl',
          'select'
        ];
        if (this.widthDisplay < 600) {
          this.displayedColumns = ['select', 'mobileWrapper'];
        }
        return;
      case DocTypeEnum.import:
        this.displayedColumns = [
          'id',
          'description',
          'brand',
          'article',
          'price',
          'stock',
          'priceControl',
          'quanControl',
          'action',
          'select'
        ];
        if (this.widthDisplay < 600) {
          this.displayedColumns = ['select', 'mobileWrapper'];
        }
        return;
      case DocTypeEnum.order:
        this.displayedColumns = [
          'id',
          'img',
          'description',
          'brand',
          'article',
          'retail',
          'stock',
          'priceControl',
          'quanControl',
          'select'
        ];
        break;
      case DocTypeEnum.buy:
        this.displayedColumns = [
          'id',
          'description',
          'brand',
          'article',
          'stock',
          'priceControl',
          'quanControl',
          'select'
        ];
        break;
      default:
        this.displayedColumns = [
          'id',
          'description',
          'brand',
          'article',
          'retail',
          'stock',
          'quanControl',
          'select'
        ];
        if (this.analogueSelector) {
          this.displayedColumns = [
            'id',
            'img',
            'description',
            'brand',
            'article',
            'stock',
            'select'
          ];
        }
        if (this.widthDisplay < 600) {
          this.displayedColumns = ['select', 'mobileWrapper'];
        }
        return;
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.focusTimer) clearTimeout(this.focusTimer);
  }

  private keyboardQuery(): string {
    return JSON.stringify(this.searchForm.getRawValue());
  }

  private keyboardResultsReady(): boolean {
    return this.keyboardMode && !this.loading && !this.destroyed &&
      this.keyboardResultQuery === this.keyboardQuery() && this.dataSource.data.length > 0;
  }

  onSearchKeyboard(event: KeyboardEvent): void {
    if (!this.keyboardMode || event.isComposing || event.defaultPrevented) return;
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey || event.altKey)) {
      event.preventDefault(); event.stopPropagation();
      return;
    }
    const field = (event.target as HTMLElement | null)?.getAttribute('formControlName');
    if (!field || !['article', 'description', 'barcode'].includes(field)) return;
    if (event.key !== 'ArrowDown' || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey ||
      !this.keyboardResultsReady()) return;
    event.preventDefault(); event.stopPropagation();
    this.focusKeyboardRow(0);
  }

  onResultKeyboard(event: KeyboardEvent, product: Product): void {
    // Inputs, checkboxes and links inside a row keep their own keyboard behavior.
    if (!this.keyboardMode || event.target !== event.currentTarget || event.isComposing || event.defaultPrevented) return;
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey || event.altKey)) {
      event.preventDefault(); event.stopPropagation();
      return;
    }
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || !this.keyboardResultsReady()) return;
    const index = this.dataSource.data.findIndex((row) => row.id === product.id);
    if (index < 0) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); event.stopPropagation();
      this.focusKeyboardRow(Math.max(0, Math.min(this.dataSource.data.length - 1,
        index + (event.key === 'ArrowDown' ? 1 : -1))));
    } else if (event.key === 'Enter') {
      event.preventDefault(); event.stopPropagation();
      if (event.repeat || this.keyboardChoosing) return;
      this.keyboardChoosing = true;
      this.keyboardProductChosen.emit(product);
    }
  }

  get canChooseReceivingProduct(): boolean {
    return this.keyboardResultsReady() && !this.keyboardChoosing;
  }

  chooseReceivingProduct(product: Product): void {
    if (!this.canChooseReceivingProduct) return;
    this.keyboardChoosing = true;
    this.keyboardProductChosen.emit(product);
  }

  releaseKeyboardSelection(): void {
    this.keyboardChoosing = false;
  }

  private focusKeyboardRow(index: number): void {
    if (!this.keyboardResultsReady()) return;
    const element = this.keyboardRows?.toArray()[index]?.nativeElement;
    const product = this.dataSource.data[index];
    if (!element || !product) return;
    this.keyboardActiveId = product.id;
    element.focus();
    element.scrollIntoView({ block: 'nearest' });
  }

  get article() {
    return this.searchForm.value.article;
  }

  get brand() {
    return this.searchForm.value.brand;
  }

  get description() {
    return this.searchForm.value.description;
  }

  get barcode() {
    return this.searchForm.value.barcode;
  }

  get brandControl() {
    return this.searchForm.controls.brand as UntypedFormControl;
  }

  openPrintDialog(prod: Product) {
    if (prod.barcodes && prod.barcodes.length > 0 && prod.barcodes[0].barcode !== '') {
      const dialog = this.dialog.open(LabelPrintComponent);
      dialog.componentInstance.productId = prod.id;
      dialog.componentInstance.barcode = prod.barcodes[0].barcode;
    } else {
      this.notificationService.warning('У товара нет штрихкода!');
    }
  }

  getWarehouse(product: Product) {
    if (this.defaultWarehouse) {
      const warehouse = (product.stock || []).find((wh) => {
        return wh.warehouse?.id === this.defaultWarehouse?.id;
      });
      return warehouse;
    } else {
      return null;
    }
  }

  getStockQuantity(stock: ProductInWarehouse): number {
    if (this.movingRouteMode) return Number(stock.quan || 0);
    const free = Number(stock.freeQuantity ?? (Number(stock.quan || 0) -
      Number(stock.customerReservedQuantity || 0) - Number(stock.transferReservedQuantity || 0)));
    return Number.isFinite(free) ? Math.max(Math.round(free * 100) / 100, 0) : 0;
  }

  sortStock(product: Product) {
    const stock = [...(product.stock || [])].sort((a, b) => {
      if (a.warehouse.id === this.defaultWarehouse?.id) return -1;
      if (b.warehouse.id === this.defaultWarehouse?.id) return 1;
      return 0;
    });
    return stock;
  }

  getMovingWarehouseLabel(warehouse: Warehouse | null | undefined, fallback: string) {
    return warehouse?.description || fallback;
  }

  getMovingCurrentStock(product: Product, warehouse: Warehouse | null | undefined) {
    return this.getMovingBaselineStock(product, warehouse?.id);
  }

  getMovingStockAfter(product: Product, side: 'from' | 'to') {
    const warehouse = side === 'from' ? this.movingWarehouseFrom : this.movingWarehouseTo;
    if (!warehouse?.id) return 0;

    const baseline = this.getMovingBaselineStock(product, warehouse.id);
    const qty = this.getMovingPreviewQty(product);
    if (side === 'from') return this.roundQty(baseline - qty);
    return this.roundQty(baseline + qty);
  }

  getMovingStockCell(product: Product, warehouse: Warehouse | null | undefined) {
    if (!warehouse?.id) return '';
    return this.getMovingStockRow(product, warehouse.id)?.cell || '';
  }

  isMovingStockShortage(product: Product) {
    return Boolean(this.movingWarehouseFrom?.id && this.getMovingStockAfter(product, 'from') < 0);
  }

  getMovingStockClass(product: Product, side: 'from' | 'to') {
    const after = this.getMovingStockAfter(product, side);
    if (side === 'from' && after < 0) return 'route-stock--danger';
    if (after > 0) return 'route-stock--positive';
    return 'route-stock--neutral';
  }

  search(): void {
    if (this.keyboardMode && this.loading) return;
    const keyboardQuery = this.keyboardQuery();
    this.searchError = '';
    if (!this.defaultWarehouse) {
      this.searchError = 'Не выбран склад приёмки. Закройте поиск и выберите фактический склад.';
      return;
    }
    if (this.defaultWarehouse) {
      this.searched = true;
      if (this.receivingMode) this.dataSource.data = [];
      this.loading = true;
      if (this.keyboardMode) {
        this.keyboardActiveId = null;
        this.keyboardResultQuery = '';
        this.keyboardChoosing = false;
      }
      this.productService
        .search({
          article: this.article && this.article,
          brand: typeof this.brand === 'object' ? undefined : this.brand,
          brand_id: typeof this.brand === 'object' ? this.brand.id : undefined,
          description: this.description && this.description,
          barcode: this.barcode && this.barcode,
          default_warehouse_id: this.defaultWarehouse.id,
          limit: this.docType === DocTypeEnum.import ? 20 : 30,
          offset: 0
        })
        .subscribe(
          (data) => {
            if (this.analogueSearchProductId) {
              data.data = data.data.filter((prod) => {
                return prod.id !== this.analogueSearchProductId;
              });
            }
            this.dataSource.data = data.data;
            if (this.keyboardMode) this.selection.clear();
            this.updateSelected();
            this.loading = false;
            if (this.keyboardMode) {
              this.keyboardResultQuery = keyboardQuery;
              if (this.focusTimer) clearTimeout(this.focusTimer);
              this.focusTimer = setTimeout(() => this.focusKeyboardRow(0), 0);
            }
          },
          (err) => {
            console.error(err);
            this.searchError = 'Не удалось найти товары. Повторите поиск.';
            this.loading = false;
          }
        );
    }
  }

  updateSelected(
    products: Product[] = this.dataSource.data,
    selection: SelectionModel<Product> = this.selection,
    car: CarModelType | undefined = this.car
  ) {
    if (car) {
      this.carService
        .productInCar({
          product_ids: products.map((prod) => prod.id),
          car_id: car.id
        })
        .subscribe((ids) => {
          for (let index = 0; index < ids.length; index++) {
            const id = ids[index];
            const product = products.find((prod) => prod.id === id);
            if (product) selection.toggle(product);
          }
        });
    } else {
      this.controls.controls.forEach((ctrl) => {
        const product = products.find((prod) =>
          ctrl.value.product ? prod.id === ctrl.value.product.id : prod.id === ctrl.value.id
        );
        if (product) selection.toggle(product);
      });
    }
  }

  create() {
    this.loading = true;
    this.productService
      .create({
        description: this.description,
        brand_id: this.brand.id,
        brand: this.brand,
        article: this.article,
        barcode: this.barcode
      })
      .subscribe(
        (product) => {
          this.dataSource.data = [product];
          this.toggleRow(product);
          this.loading = false;
        },
        (err) => {
          console.error(err);
          this.loading = false;
        }
      );
  }

  getPriceControl(product: Product): UntypedFormControl {
    if (this.documentEditMode) {
      return this.ensureProductDocumentControl(product).controls.price as UntypedFormControl;
    }

    const control = this.controls.controls.find(
      (ctrl) => ctrl.value.product.id === product.id
    ) as UntypedFormGroup;
    const priceControl = control?.controls.price as UntypedFormControl;
    return priceControl || new UntypedFormControl();
  }

  getQuanControl(product: Product): UntypedFormControl {
    if (this.documentEditMode) {
      return this.ensureProductDocumentControl(product).controls.quan as UntypedFormControl;
    }

    const control = this.controls.controls.find(
      (ctrl) => ctrl.value.product.id === product.id
    ) as UntypedFormGroup;
    const quanControl = control?.controls.quan as UntypedFormControl;
    return quanControl || new UntypedFormControl();
  }

  getProductControl(product: Product): UntypedFormGroup {
    if (this.documentEditMode) {
      return this.ensureProductDocumentControl(product);
    }

    const control = this.controls.controls.find(
      (ctrl) => ctrl.value.product.id === product.id
    ) as UntypedFormGroup;
    return control || new UntypedFormGroup({});
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.toggleAllProductEvent.emit([...this.dataSource.data]);
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  private getImageUrls(product: Product): string[] {
    return (product.images || []).map((image) => {
      const name = String(image.name || '').trim();
      if (/^https?:\/\//i.test(name)) return name;
      if (name && !name.startsWith('supplier-remote-') && !name.includes('/')) {
        return `${environment.BACKEND}/image/${encodeURIComponent(name)}`;
      }
      const url = String(image.url || '').trim();
      return /^https?:\/\//i.test(url) ? url : null;
    }).filter((url): url is string => !!url && !this.failedImageUrls.has(url));
  }

  getImg(product: Product): string | null {
    return this.getImageUrls(product)[0] || null;
  }

  handleImageError(url: string): void {
    this.failedImageUrls.add(url);
  }

  openProductPhotos(product: Product): void {
    const images = this.getImageUrls(product);
    if (!images.length) return;
    this.dialog.open(PartPhotoViewerDialogComponent, {
      data: { images, index: 0, title: product.description || 'Фото товара' },
      panelClass: 'part-photo-viewer-panel',
      width: '96vw',
      maxWidth: '96vw',
      height: '92vh',
      autoFocus: 'first-tabbable',
      restoreFocus: true
    });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Product, position?: number): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${position}`;
  }

  toggleRow(row: Product) {
    this.toggleProductEvent.emit(row);
    const find = this.selection.selected.find((prod) => prod.id === row.id);
    if (find) {
      this.removeProductEvent.emit(row);
    } else {
      this.addProductEvent.emit(row);
    }
    this.selection.toggle(row);
  }

  handleChangeQuan(product: Product) {
    if (this.documentEditMode) {
      const control = this.ensureProductDocumentControl(product);
      if (this.changeRow) this.changeRow(control, 'quan');
      return;
    }

    const control = this.controls.controls.find(
      (ctrl) => ctrl.value.product.id === product.id
    ) as UntypedFormGroup;
    if (!control) this.toggleRow(product);
    if (this.changeRow) this.changeRow(this.getProductControl(product), 'quan');
  }

  handleChangePrice(product: Product) {
    if (this.documentEditMode) {
      const control = this.ensureProductDocumentControl(product);
      if (this.changeRow) this.changeRow(control, 'price');
      return;
    }

    const control = this.controls.controls.find(
      (ctrl) => ctrl.value.product.id === product.id
    ) as UntypedFormGroup;
    if (!control) this.toggleRow(product);
    if (this.changeRow) this.changeRow(this.getProductControl(product), 'price');
  }

  private getMovingRouteColumns() {
    if (this.widthDisplay < 600) {
      return ['select', 'mobileWrapper'];
    }

    return [
      'id',
      'img',
      'description',
      'brand',
      'article',
      'movingFromStock',
      'movingToStock',
      'quanControl',
      'select'
    ];
  }

  private getMovingPreviewQty(product: Product) {
    const control = this.controls.controls.find(
      (ctrl) => ctrl.value.product?.id === product.id
    ) as UntypedFormGroup | undefined;
    const qty = Number(control?.value?.quan || 1);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  private getMovingBaselineStock(product: Product, warehouseId?: number | null) {
    if (!warehouseId) return 0;

    let stock = this.getMovingStockRow(product, warehouseId)?.quan || 0;
    if (this.movingOriginalPassed) {
      const originalQty = Number(this.movingOriginalQuantities?.[product.id] || 0);
      if (warehouseId === this.movingOriginalWarehouseFromId) stock += originalQty;
      if (warehouseId === this.movingOriginalWarehouseToId) stock -= originalQty;
    }

    return this.roundQty(stock);
  }

  private getMovingStockRow(product: Product, warehouseId: number): ProductInWarehouse | undefined {
    return (product.stock || []).find((row) => row.warehouse?.id === warehouseId);
  }

  private roundQty(value: number) {
    return Math.round(Number(value || 0) * 100) / 100;
  }

  private ensureProductDocumentControl(product: Product): UntypedFormGroup {
    let control = this.controls.controls.find(
      (ctrl) => ctrl.value.product?.id === product.id
    ) as UntypedFormGroup;

    if (!control) {
      control = new UntypedFormGroup({
        product: new UntypedFormControl(product),
        price: new UntypedFormControl(Number(product.retail || product.price || 0)),
        quan: new UntypedFormControl(1)
      });
      this.controls.push(control);
    }

    return control;
  }

  openDialog(product: Product) {
    if (!this.user) return;
    const dialogRef = this.dialog.open(CardComponent, {
      width: '1700px',
      height: '800px'
    });
    dialogRef.componentInstance.product = product;
    dialogRef.componentInstance.defaultWarehouse = this.user.defaultWarehouse;
  }
}
